module.exports = __webpack_public_path__ + "img/33.b7742484.png";